import * as angular from 'angular';

import { ReportSchedulesListComponent } from './report-schedules-list.component';
import { ReportSchedulesListService } from './report-schedules-list.service';

angular
  .module('report-schedules-list', [])
  .component('reportSchedulesList', ReportSchedulesListComponent)
  .service('ReportSchedulesListService', ReportSchedulesListService);
